module.exports = __webpack_public_path__ + "static/img/user-comment5.86f8cea.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/user-comment5.png
// module id = 7jFz
// module chunks = 0